// extracted by mini-css-extract-plugin
export var dayLabel = "_l5-0";
export var pickerDisabled = "_l5-1";